import { useLooseProductContextSelector } from 'src/components/restructure/product/contexts'
import { InView } from 'react-intersection-observer'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import type { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { RulerSizeIcon } from 'src/components/Icons/RulerSizeIcon'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import './styles.scss'

export function SizeGuide({
  openSizeGuideModal,
  featureDetailsObject,
  isFirstFoldRevampEnabled = false,
}: {
  openSizeGuideModal: () => void
  featureDetailsObject: ReturnType<typeof getFeatureObject>
  isFirstFoldRevampEnabled?: boolean
}) {
  const product = useLooseProductContextSelector((ctx) => ctx.product)
  const { pageData } = useGlobalContext()

  if (!product?.sizeDetails) {
    return null
  }

  const sendPromoFeatureViewedEvent = () => {
    const eventData = {
      ...getStandardObject(pageData),
      ...featureDetailsObject,
    }

    dispatchAmplitudeEvent({ eventName: 'Product Feature Viewed', eventData })
  }

  const defaultButtonClassName =
    'desktop-caption-regular text-white bg-[#151818] cursor-pointer flex items-center justify-center gap-[6px] px-4 py-[7px] rounded'

  const revampMobileButtonClassName =
    'cursor-pointer flex items-center gap-[6px] text-[12px] font-normal leading-[12px] tracking-[0.48px] uppercase underline text-black restructure-small-desktop:hidden'

  return (
    <InView
      key={product.productId}
      as="div"
      threshold={0.7}
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          sendPromoFeatureViewedEvent()
        }
      }}
    >
      {isFirstFoldRevampEnabled ? (
        <>
          <button
            className={revampMobileButtonClassName}
            onClick={openSizeGuideModal}
          >
            <RulerSizeIcon color="black" />
            Saiba como medir
          </button>
          <button
            className={`hidden restructure-small-desktop:flex ${defaultButtonClassName}`}
            onClick={openSizeGuideModal}
          >
            <RulerSizeIcon color="#fff" />
            Saiba como medir
          </button>
        </>
      ) : (
        <button className={defaultButtonClassName} onClick={openSizeGuideModal}>
          <RulerSizeIcon color="#fff" />
          Saiba como medir
        </button>
      )}
    </InView>
  )
}
